import * as React from "react";
import { gql, useMutation, ApolloError, MutationTuple } from "@apollo/client";

import {
  UpdateMyBankPreferenceMutationMutation,
  UpdateMyBankPreferenceMutationMutationVariables
} from "../../../schemaTypes";

export const updateMyBankPreferenceMutation = gql`
  mutation UpdateMyBankPreferenceMutation(
    $bankPreferenceId: String!, 
    $input: UpdateMyBankPreferenceInput!
  ) {
    updateMyBankPreference(
      bankPreferenceId: $bankPreferenceId, 
      input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export const UpdateMyBankPreference: React.FC<{ children: (data: {
  updateMyBankPreference: MutationTuple<
    UpdateMyBankPreferenceMutationMutation, 
    UpdateMyBankPreferenceMutationMutationVariables
  >[0];
  loading: boolean;
  error?: ApolloError;
  data?: UpdateMyBankPreferenceMutationMutation;
  errors?: { path: string; message: string }[] | null;
  message?: string | null;
}) => React.ReactElement | null }> = ({ children }) => {
  const [updateMyBankPreference, { loading, error, data }] = useMutation<UpdateMyBankPreferenceMutationMutation, UpdateMyBankPreferenceMutationMutationVariables>(updateMyBankPreferenceMutation);

  // Extract errors and message from the mutation result, matching resolver response
  const errorsRaw = data?.updateMyBankPreference?.errors ?? null;
  const errors = Array.isArray(errorsRaw)
    ? errorsRaw.filter((e): e is { path: string; message: string } => !!e)
    : errorsRaw;
  const message = data?.updateMyBankPreference?.message ?? null;

  return children({
    updateMyBankPreference,
    loading,
    error,
    data: data ?? undefined,
    errors,
    message
  });
};
